<template>
  <button class="primary" @click.prevent="onClick" v-bind="$attrs">
    <slot>Default</slot>
  </button>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BlueButton',
  props: {
    onClick: {
      type: Function,
      required: true,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
})
class BlueButton extends Vue {

}

export default BlueButton;

</script>

<style lang="scss" scoped>
.primary {
  align-items: center;
  background-color: #173945;
  border-radius: 8px;
  border: solid 1px #4e97b2;
  color: #fff;
  font-size: 19px;
  min-height: 40px;
  padding: 8px 32px;
  text-decoration: none;
  max-width: min-content;
  text-align: center;
  white-space: nowrap;

  &:hover,
  &:focus,
  &:focus-visible {
    border: solid 1px #4e97b2;
    background-color: #316273;
  }
}
</style>
